import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

import { useSelector } from "react-redux";

import TopPanel from './HomePanels/TopPanel';
import Manuals from './HomePanels/Manuals';
import Bookmarks from './HomePanels/Bookmarks';
import KdcNews from './HomePanels/KdcNews';
import Banners from './HomePanels/Banners';
import YlwNews from './HomePanels/YlwNews';
import Products from './HomePanels/Products';
import PopUp from './Common/PopUp';

const Home = (props) => {
    //page
    const history = useNavigate();

    const LoginStates = useSelector(state => state.login);
    const [searchword, setSearchWord] = useState('');

    const [surveyContent, setSurveyContent] = useState(null);
    useEffect(() => {
        const rootElement = document.getElementById('root');
        rootElement.classList.add('home');
        setSurveyContent(
            (!getCookie('surveyClosed') ?
                <div className="msg-popup renew">
                    <div className="box" style={{ "width": "100%" }}>
                        <button className="btn-close" onClick={() => setSurveyContent(null)}>
                            <i className="icoKdc32 close"></i>
                        </button>
                        <div className="img-wrap">
                            <img src="kdc-ad.png" style={{ "width": "1000px" }} />
                        </div>
                        <button onClick={closeSurveyPopup} className="btn-never">다시 열지 않기</button>
                    </div>
                </div> : null
            )
        );
        return (() => {
            rootElement.classList.remove('home');
        })

    }, []);



    const closeSurveyPopup = (value) => {
        if (value) {
            document.cookie = 'surveyClosed=true';
        }
        setSurveyContent(null);
    };

    const getCookie = (name) => {
        return document.cookie.split('; ').reduce((r, v) => {
            const parts = v.split('=');
            return parts[0] === name ? decodeURIComponent(parts[1]) : r;
        }, '');
    };
    return (
        <section className="container">
            <TopPanel />
            {(localStorage.getItem("manualHistory") || LoginStates.sessionId !== "") && (
                <section className="manuals">
                    {localStorage.getItem("manualHistory") && <Manuals />}
                    {LoginStates.sessionId !== "" && <Bookmarks />}
                </section>
            )}
            <KdcNews />
            <Banners />
            <YlwNews />
            <Products />
            {/*{!getCookie('surveyClosed') ? <PopUp content={surveyContent} setContent={closeSurveyPopup} /> : null}*/}
        </section >
    );
}
export default Home;